import { useContext } from 'react'
import { RosterSearchContext } from 'recruiter/contexts'

/**
 * Provides access to values in the roster search context.
 */
export const useRosterSearch = () => {
    const rosterSearchContext = useContext(RosterSearchContext)

    if (!rosterSearchContext) {
        throw new Error(
            'useRosterSearch must be used within <RosterSearchProvider>'
        )
    }

    return rosterSearchContext
}
